import { Subject } from "@carnegie-learning/cure-types";
import { FeathersServicePagination } from "@carnegie-learning/data-access-core";
import { createAction, props } from "@ngrx/store";

export const LOAD_ACTIVESUBJECTS = "[Courses] Load Active Subjects";
export const LOAD_ACTIVESUBJECTS_FAIL = "[Courses] Load Active Subjects Fail";
export const LOAD_ACTIVESUBJECTS_SUCCESS =
    "[Courses] Load Active Subjects Success";

export const LoadActiveSubjects = createAction(
    LOAD_ACTIVESUBJECTS,
    props<{
        payload: string //TODO: CURE: use schoolID
    }>()
);

export const LoadActiveSubjectsFail = createAction(
    LOAD_ACTIVESUBJECTS_FAIL,
    props<{
        payload: any
    }>()
);

export const LoadActiveSubjectsSuccess = createAction(
    LOAD_ACTIVESUBJECTS_SUCCESS,
    props<{
        payload: FeathersServicePagination<Subject>
    }>()
);
